
import BlogHtmlFile from '~/components/Common/Blog/BlogHtmlFile'

export default {
    components: {
        BlogHtmlFile,
    },
}
